import { Component, h, Host, Prop } from "@stencil/core";
import { QuickAddButtonProps } from "./f-quick-add-button-model";

@Component({
  tag: "f-quick-add-button",
})
export class QuickAddButton {
  @Prop() hiddenLabel: QuickAddButtonProps["hiddenLabel"] = "Quick add";
  @Prop() titleLabel: QuickAddButtonProps["titleLabel"] = this.hiddenLabel;
  @Prop() bcpContextPath: QuickAddButtonProps["bcpContextPath"];

  render() {
    return (
      <Host data-test="quick-add-button">
        <f-button-with-badge
          iconName="shoppingcart-add"
          buttonTitle={this.titleLabel}
          iconOnly={true}
          class="js-quick-add-btn"
          data-quick-add-url={`${this.bcpContextPath}quickAdd`}
        >
          <f-visually-hidden>{this.hiddenLabel}</f-visually-hidden>
        </f-button-with-badge>
      </Host>
    );
  }
}
